import { useState, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from '../Sidebar/Sidebar';
import AppBar from '../AppBar/AppBar';
import styles from './Layout.module.css';
import NodeMonitorAlerts from '../../pages/NodeMonitorPage/NodeMonitorAlerts';

interface LayoutProps {
  children: ReactNode;
  isAuthenticated: boolean;
  onLogout: () => void;
}

export default function Layout({ 
  children, 
  isAuthenticated, 
  onLogout 
}: LayoutProps) {
  const location = useLocation();
  const isStartPage = location.pathname === '/';
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => setIsSidebarOpen(prev => !prev);
  const closeSidebar = () => setIsSidebarOpen(false);

  if (isStartPage || !isAuthenticated) {
    return <>{children}</>;
  }

  return (
    <div className={styles.layout}>
      <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />

      <div
        className={`${styles.mainWrapper} ${
          isSidebarOpen ? styles.withSidebar : ''
        }`}
      >
        <AppBar
          isAuthenticated={isAuthenticated}
          onLogout={onLogout}
          onToggleSidebar={toggleSidebar}
          isSidebarOpen={isSidebarOpen}
        />

        <NodeMonitorAlerts />
        <main className={styles.content}>
          {children}
        </main>
      </div>
    </div>
  );
}
